import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/support.svg',
})
export class SupportComponent {}
